import React, { useEffect, useState } from "react";
import DashboardLayout from "../../components/SharedLayouts/DashboardLayout";
import Loader from "../../components/SharedLayouts/Loader";
import { useDispatch, useSelector } from "react-redux";
import AdminUserIcon from "../../components/Icons/AdminUserIcon";
import { getAllUser } from "../../store/actions/userManagement/management";
import CustomButton from "../../components/Buttons/Button";
import { Box } from "@mui/system";
import { Tab, Tabs } from "@mui/material";
import AboutInvestment from "../../components/investment/AboutInvestment";
import UserInvested from "../../components/investment/UserInvested";
import PayoutHistory from "../../components/investment/PayoutHistory";
import PaymentSchedule from "../../components/investment/PaymentSchedule";
import useCurrency from "../../hooks/useCurrency";
import InvestDetailCard from "../../components/cards/InvestDetailCard";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { getInvestment } from "../../store/actions/investment/getInvestment";
import StartInvestmentModal from "../../components/modal/StartInvestmentModal";
import { toggleInvestment } from "../../store/actions/investment/toggleInvestment";
import { getPayoutHistory } from "../../store/actions/investment/getPayoutHistory";
import { deleteInvestment } from "../../store/actions/investment/deleteInvestment";
import ConfirmDeleteModal from "../../components/modal/ConfirmDeleteModal";
import { toggleInvestmentStatus } from "../../store/actions/investment/toggleInvestmentStatus";
import UserInterested from "../../components/investment/UserInterested";
import YouTube from "react-youtube";
import BackArrow2 from "../../components/BackArrow2";
import UserTable from "../../components/dashboard/user/UserTable";
import InvestForUser from "../../components/modal/InvestForUser";
import { getRealEstateInvestment } from "../../store/actions/investment/getRealEstateInvestment";
import TimelineModal from "../../components/modal/TimelineModal";
import UpdatTimelineModal from "../../components/modal/UpdatTimelineModal";
import { deleteRealEstateInvestment } from "../../store/actions/investment/deleteRealEstateInvestment";
import { getCurrencySymbol } from "../../Helper/getCurrencySymbol";
import { toggleRealEstateInvestmentStatus } from "../../store/actions/investment/toggleRealEstateInvestmentStatus";
import { editBusinessProduct } from "../../store/actions/businesses/editBusinessProduct";
import { getRealEstatePayoutHistory } from "../../store/actions/investment/getRealEstatePayoutHistory";
import PayoutModal from "../../components/modal/PayoutModal";
import MudarabahPayoutModal from "../../components/modal/MudarabahPayoutModal";
import ConfirmCloseOut from "../../components/modal/ConfirmCloseOut";
import ETCBreakDownModal from "../../components/modal/ETCBreakDownModal";

function InvestmentDetail() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loadingToogle, setLoadingToogle] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState();
  const [showTimelines, setShowTimelines] = useState(false);
  const [openPayoutModal, setOpenPayoutModal] = useState(false);
  const [closeOutList, setCloseOutList] = useState([]);
  const [isInvesting, setIsInvesting] = useState(false);
  const { state } = useLocation();
  const investment = useSelector((state) => state?.investment?.investment);

  const pending = useSelector((state) => state?.investment?.pending);
  const togglePending =
    useSelector((state) => state?.investment?.togglePending) || false;
  const toggleStatusPending =
    useSelector((state) => state?.investment?.toggleStatusPending) || false;
  const payoutHistory =
    useSelector((state) => state?.investment?.payoutHistory) || [];

  const [activeTab, setActiveTab] = useState("about");
  const [_currency, getAmount] = useCurrency();
  const [openModal, setOpenModal] = useState(false);
  const [openBreakDownModal, setOpenBreakDownModal] = useState(false);
  const [openMudarabahModal, setOpenMudarabahModal] = useState(false);
  const [manualCloseModal, setManualCloseModal] = useState(false);
  const [continueCloseOut, setContinueCloseOut] = useState(false);
  const [openStartModal, setOpenStartModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const { id } = useParams();
  const user = useSelector((state) => state.onboarding.user);

  const handleCloseStartModal = () => {
    setOpenStartModal(false);
  };

  const isMudarabah =
    state?.cycle?.investment_type?.toLocaleLowerCase() === "mudarabah";

  // Every campaign type records its payouts against the cycle, so the cycle
  // payout list fills the Payment History table for all of them.
  // getPayoutHistory returns the aggregate behind the "Paid Out" card, not
  // rows, so both calls are needed.
  const refreshPayoutHistory = () => {
    dispatch(getRealEstatePayoutHistory({ id, cycle_id: state?.cycle?.id }));
    dispatch(getPayoutHistory({ id }));
  };

  useEffect(() => {
    dispatch(getAllUser());
    if (state?.type === "Real Estate") {
      dispatch(getRealEstateInvestment(id));
    } else {
      dispatch(getInvestment(id));
    }
    refreshPayoutHistory();
  }, [state]);

  const handleDelete = () => {
    dispatch(deleteInvestment({ id: state?.cycle?.id || id, navigate }));
    setShowDeleteModal(false);
    navigate(-1);
  };

  const [loadingDelete, setLoadingDelete] = useState(false);
  const handleDeleteRealEstate = (id) => {
    setLoadingDelete(true);
    dispatch(
      deleteRealEstateInvestment({
        id: id,
        navigate,
        cb: () => {
          setShowDeleteModal(false);
          setLoadingDelete(false);
          navigate(-1);
        },
        failed: () => {
          setShowDeleteModal(false);
          setLoadingDelete(false);
        },
      }),
    );
  };

  const handleEditInvestment = () => {
    if (state?.cycle) {
      navigate(`/business/product/edit/${state?.cycle?.id}`, {
        state: {
          cycle: state?.cycle,
          name: state?.cycle?.name,
          investment_id: id,
        },
      });
    } else {
      navigate("/edit-investment/" + id);
    }
  };

  const handleInvestForAUser = () => {};

  const [upcomingLoading, setUpcomingLoading] = useState(false);
  const handleToggleUpcoming = () => {
    setUpcomingLoading(true);
    const data = {
      status:
        investment?.investment_status == "9" || investment?.status == "9"
          ? "1"
          : "9",
    };

    if (state?.cycle) {
      const formData = new FormData();

      formData.append("status", state?.cycle?.status == "9" ? 1 : 9);

      dispatch(
        editBusinessProduct({
          payload: formData,
          id: state?.cycle?.id,
          setUpcomingLoading,
          cb: () => {
            navigate(-1);
          },
        }),
      );
    } else if (investment?.investment_category?.name === "Real Estate") {
      dispatch(
        toggleRealEstateInvestmentStatus({
          data,
          id,
          cb: () => {
            setUpcomingLoading(false);
          },
        }),
      );
    } else {
      dispatch(
        toggleInvestment({
          data,
          id: id,
          cb: () => {
            setUpcomingLoading(false);
          },
          failed: () => {
            setUpcomingLoading(false);
          },
        }),
      );
    }
  };

  const handleToggle = () => {
    setLoadingToogle(true);
    const data = {
      status:
        investment?.investment_status != "0" || investment?.status != "0"
          ? "0"
          : "1",
    };
    if (investment?.investment_category?.name === "Real Estate") {
      dispatch(
        toggleRealEstateInvestmentStatus({
          data,
          id,
          cb: () => {
            setLoadingToogle(false);
          },
        }),
      );
    } else {
      dispatch(
        toggleInvestment({
          data,
          id,
          cb: () => {
            setLoadingToogle(false);
          },
          failed: () => {
            setLoadingToogle(false);
          },
        }),
      );
    }
  };

  const [loadindActivateInvestment, setLoadindActivateInvestment] =
    useState(false);
  const handleStatusToggle = () => {
    setLoadindActivateInvestment(true);
    const data = {
      status: investment?.status == "0" ? "1" : "0",
    };
    if (investment?.investment_category?.name === "Real Estate") {
      dispatch(
        toggleRealEstateInvestmentStatus({
          data,
          id,
          cb: () => {
            setLoadindActivateInvestment(false);
          },
          failed: () => {
            setLoadindActivateInvestment(false);
          },
        }),
      );
    } else {
      dispatch(
        toggleInvestmentStatus({
          data,
          id,
          cb: () => {
            setLoadindActivateInvestment(false);
          },
          failed: () => {
            setLoadindActivateInvestment(false);
          },
        }),
      );
    }
  };

  const investDetails = state?.cycle
    ? [
        {
          id: 1,
          icon: <AdminUserIcon />,
          title: "Investment Target:",
          cardValue: state?.cycle?.amount,
        },
        {
          id: 2,
          icon: <AdminUserIcon />,
          title: "Amount:",
          cardValue: state?.cycle?.paymentSchedules?.total_amount,
        },

        {
          id: 3,
          title: "Amount Paid Out:",
          cardValue: state?.cycle?.total_amount_disbursed,
        },
        {
          id: 4,
          title: "Number of Investors:",
          cardContent: state?.cycle?.investors?.length,
        },
        {
          id: 5,
          title: "Investment Category:",
          cardContent: investment?.investment_category?.name,
        },
        {
          id: 6,
          title: "Investment Sector:",
          cardContent: investment?.sector,
        },
        {
          id: 7,
          title: "Payment Frequency:",
          cardContent: state?.cycle?.repayment_type,
        },
        {
          id: 8,
          title: isMudarabah ? "ROI Range" : "Expected ROI:",
          cardContent: isMudarabah
            ? `(${state?.cycle?.roi_range?.min_roi} - ${state?.cycle?.roi_range?.max_roi}%)`
            : state?.cycle?.roi,
        },
        {
          id: 9,
          title: "Investment Duration:",
          cardContent: `${state?.cycle?.duration} Month${
            Number(state?.cycle?.duration) == 1 ? "" : "s"
          }`,
        },
        {
          id: 10,
          title: "Due Date:",
          cardContent: new Date(state?.cycle?.due_date).toDateString(),
        },
      ]
    : [
        {
          id: 1,
          icon: <AdminUserIcon />,
          title: "Investment Target:",
          cardValue:
            investment?.investment_category?.slug === "property"
              ? investment?.amount_per_unit * investment?.total_units
              : investment?.maximum_amount,
        },
        {
          id: 2,
          icon: <AdminUserIcon />,
          title: "Amount Invested:",
          cardContent: `${getCurrencySymbol(investment?.currency)} ${
            investment?.total_amount_invested
              ? getAmount(Number(investment?.total_amount_invested), 2)
              : "-"
          }`,
        },

        {
          id: 3,
          title: "Amount Paid Out:",
          cardValue: payoutHistory?.total_amount_disbursed,
        },
        {
          id: 4,
          title: "Number of Investors:",
          cardContent:
            investment?.investment_category?.slug === "property"
              ? investment?.investors?.length
              : investment?.investments?.length,
        },
        {
          id: 5,
          title: "Investment Category:",
          cardContent: investment?.investment_category?.name,
        },
        // {
        //   id: 6,
        //   title: "Investment Sector:",
        //   cardContent: investment?.sector,
        // },
        {
          id: 7,
          title: "Payment Frequency:",
          cardContent: investment?.payout_type || "",
        },
        {
          id: 8,
          title: "Expected ROI:",
          cardContent:
            investment?.investment_category?.slug === "property"
              ? investment?.annual_roi
              : investment?.roi,
        },
        {
          id: 9,
          title: "Investment Duration:",
          cardContent:
            investment?.investment_category?.slug === "property"
              ? `${investment?.property_appreciation} Year${
                  investment?.property_appreciation === 1 ? "" : "s"
                }`
              : investment?.duration + " " + investment?.duration_type,
        },
        // {
        //   id: 10,
        //   title: "Campaign Start Date:",
        //   cardContent: new Date(investment?.campaign_start_date).toDateString(),
        // },
        {
          id: 11,
          title: "Campaign Due Date:",
          cardContent: investment?.campaign_due_date
            ? new Date(investment?.campaign_due_date).toDateString()
            : "-",
        },
      ];

  const tabStyle = {
    backgroundColor: "#fff",
    width: "fit-content",
    // h: "32px",
    margin: "4px",

    textAlign: "center",
    // margin: "30px px",
    borderBottomColor: "transparent",
    boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)",
    borderRadius: "5px",
    textTransform: "capitalize",
    fontWeight: 600,
  };

  const generalStyle = {
    textTransform: "capitalize",
    fontSize: "14px",
    color: "#667085",
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const getYoutubeVideoId = (url) => {
    const regExp =
      /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const match = url?.match(regExp);

    return match ? match[1] : null;
  };
  return (
    <DashboardLayout>
      {manualCloseModal ? (
        <>
          <div className="flex items-center mb-8">
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <Link
              to={"/investment"}
              className="font=[500] text-[#475467] text-base hidden sm:flex"
            >
              Investment
            </Link>
            <Link to={"/investment"}>
              <img
                src="/Assets/userDot.png"
                alt=""
                className="w-8 h-8 flex sm:hidden"
              />
            </Link>
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <span className="font-[500] text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md ">
              Investment Detail
            </span>
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <span className="font-[500] text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md ">
              Select a User
            </span>
          </div>
          <div className="justify-between items-center flex">
            <BackArrow2
              handleSelf={() => setManualCloseModal(false)}
              mb={10}
              ml={0}
            />
            <CustomButton
              variant="contained"
              customColor="#159AA8"
              children={"Review"}
              width="200px"
              height="50px"
              padding="10px"
              onClick={() => setContinueCloseOut(true)}
            />
          </div>
          <UserTable
            type={"SELECT"}
            rows={state?.cycle?.investors?.map((user) => user?.user)}
            setSelectedUser={(user) => {}}
            handleRowSelectionModelChange={(payload) => {
              setCloseOutList(payload);
            }}
          />
          {continueCloseOut ? (
            <ConfirmCloseOut
              open={continueCloseOut}
              closeOutList={closeOutList}
              refresh={() => {
                setContinueCloseOut(false);
                setManualCloseModal(false);
              }}
              invID={id}
              cycle={state?.cycle}
              type={
                investment?.investment_category?.name === "Real Estate"
                  ? "Real Estate"
                  : "Manual"
              }
              onCloseParent={() => {
                setContinueCloseOut(false);
                setManualCloseModal(false);
              }}
              onClose={() => setContinueCloseOut(false)}
            />
          ) : (
            <></>
          )}
        </>
      ) : isInvesting ? (
        <>
          <div className="flex items-center mb-8">
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <Link
              to={"/investment"}
              className="font=[500] text-[#475467] text-base hidden sm:flex"
            >
              Investment
            </Link>
            <Link to={"/investment"}>
              <img
                src="/Assets/userDot.png"
                alt=""
                className="w-8 h-8 flex sm:hidden"
              />
            </Link>
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <span className="font-[500] text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md ">
              Investment Detail
            </span>
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <span className="font-[500] text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md ">
              Select a User
            </span>
          </div>
          <BackArrow2 handleSelf={() => setIsInvesting(false)} mb={10} ml={0} />
          <UserTable
            type={"SELECT"}
            setSelectedUser={(user) => {
              setIsInvesting({ type: "INVEST", user });
            }}
          />
          {isInvesting?.type === "INVEST" ? (
            <InvestForUser
              open={isInvesting?.type === "INVEST"}
              userId={isInvesting?.user?.id}
              onClose={() => setIsInvesting({ type: "SELECT_USER" })}
              investment={investment}
              cycle={state?.cycle}
            />
          ) : (
            <></>
          )}
        </>
      ) : (
        <div className="px-8">
          <div className="flex items-center mb-8">
            <img src="/Assets/bread.png" alt="" className="w-8 h-8 mr-2" />
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <Link
              to={"/investment"}
              className="font=[500] text-[#475467] text-base hidden sm:flex"
            >
              Investment
            </Link>
            <Link to={"/investment"}>
              <img
                src="/Assets/userDot.png"
                alt=""
                className="w-8 h-8 flex sm:hidden"
              />
            </Link>
            <img src="/Assets/chev.png" alt="" className="w-8 h-8 mr-2" />
            <span className="font-[500] text-[#475467] text-base bg-[#F9FAFB] p-1 rounded-md ">
              Investment Detail
            </span>
          </div>
          <BackArrow2 mb={10} ml={0} />

          <div className="">
            <div className="flex flex-col md:flex-row flex-wrap justify-between items-center mb-4 w-full md:gap-10">
              <h1 className="mb-4 md:mb-0 font-[600] text-2xl md:text-3xl min-w-[max-content] capitalize">
                {state?.cycle?.name || investment?.name}
              </h1>
              <div className="w-full overflow-x-auto mb-4 md:mb-0">
                <div className="flex items-center w-[max-content] xl:w-full justify-end gap-[24px] ">
                  {user?.roles &&
                    !user?.roles?.some(
                      (role) => role.name === "Admin_Tier_1",
                    ) && (
                      <div
                        onClick={() => setShowDeleteModal(true)}
                        className="cursor-pointer text-sm font-[600] text-[#D92D20] md:mb-0 md:mr-2 !w-[max-content]"
                      >
                        Delete Investment
                      </div>
                    )}
                  {investment?.investment_category?.name === "Real Estate" ? (
                    <div className=" md:mt-0 md:ml-2">
                      <CustomButton
                        variant="contained"
                        customColor="#159AA8"
                        children="Timeline"
                        width="160px"
                        height="40px"
                        padding="10px"
                        margin="15px 0"
                        color="#fff"
                        onClick={() => {
                          setShowTimelines({
                            type: investment?.investment_category?.name,
                            investment,
                          });
                        }}
                      />
                    </div>
                  ) : (
                    <></>
                  )}
                  {!pending && !state?.cycle ? (
                    <div className="flex ">
                      <div className="md:mt-0 md:mr-3 ">
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children={
                            investment?.investment_status == "1" ||
                            investment?.status == "1"
                              ? "Close Investment"
                              : "Re-open Investment"
                          }
                          width="250px"
                          height="40px"
                          loading={loadingToogle}
                          padding="10px"
                          margin="0px 0"
                          color="#fff"
                          onClick={handleToggle}
                        />
                      </div>
                      {/* {state?.type === "Real Estate" ? (
                        <></>
                      ) : ( */}
                      <div className=" md:mt-0 md:mr-1">
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children={
                            investment?.status == "0"
                              ? "Activate Investment"
                              : "Suspend Investment"
                          }
                          width="250px"
                          height="40px"
                          loading={loadindActivateInvestment}
                          padding="10px"
                          margin="0px 0"
                          color="#fff"
                          onClick={handleStatusToggle}
                        />
                      </div>
                      {/* )} */}
                    </div>
                  ) : (
                    <></>
                  )}
                  {pending ? (
                    <></>
                  ) : (
                    <div className="md:mt-0 md:mr-3 ">
                      <CustomButton
                        variant="contained"
                        customColor="#159AA8"
                        children={
                          state?.cycle?.status == "9" ||
                          investment?.status == "9"
                            ? "Mark as Ready"
                            : "Mark as Upcoming"
                        }
                        width="250px"
                        height="40px"
                        loading={upcomingLoading}
                        padding="10px"
                        margin="0px 0"
                        color="#fff"
                        onClick={handleToggleUpcoming}
                      />
                    </div>
                  )}
                </div>
                <div className="flex items-center w-[max-content] xl:w-full justify-end gap-8 mt-3 ">
                  {user?.roles &&
                  !user?.roles?.some((role) => role.name === "Admin_Tier_1") ? (
                    <>
                      {isMudarabah ? (
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children="Mudarabah Payout"
                          width="250px"
                          height="40px"
                          padding="10px"
                          margin="0px 0"
                          color="#fff"
                          onClick={() => setOpenMudarabahModal(true)}
                        />
                      ) : (
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children="Manual Payout"
                          width="250px"
                          height="40px"
                          padding="10px"
                          margin="0px 0"
                          color="#fff"
                          onClick={() => setOpenModal(true)}
                        />
                      )}
                      {pending ? (
                        <></>
                      ) : (
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children="Manual Close Out"
                          width="250px"
                          height="40px"
                          padding="10px"
                          margin="0px 0"
                          color="#fff"
                          onClick={() => setManualCloseModal(true)}
                        />
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                  {state?.cycle ||
                  investment?.investment_category?.name?.toLowerCase() ===
                    "exchange traded commodities" ? (
                    <></>
                  ) : (
                    <div className=" md:mt-0 md:ml-2">
                      <CustomButton
                        variant="outlined"
                        customColor="#fff"
                        children="Start Investment"
                        width="250px"
                        height="40px"
                        padding="10px"
                        margin="15px 0"
                        color="#159AA8"
                        onClick={() => setOpenStartModal(true)}
                      />
                    </div>
                  )}
                  {investment?.investment_category?.name?.toLowerCase() ===
                  "exchange traded commodities" ? (
                    <CustomButton
                      variant="contained"
                      customColor="#159AA8"
                      children="Compute Loss Breakdown"
                      width="250px"
                      height="40px"
                      padding="10px"
                      margin="0px 0"
                      color="#fff"
                      onClick={() => setOpenBreakDownModal(true)}
                    />
                  ) : (
                    <></>
                  )}
                  {pending ||
                  investment?.investment_category?.name?.toLowerCase() ===
                    "exchange traded commodities" ||
                  state?.cycle?.status == "9" ||
                  investment?.status == "9" ? (
                    <></>
                  ) : (
                    <>
                      <div className=" md:mt-0 md:ml-2">
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children="Invest for a User"
                          width="300px"
                          height="40px"
                          padding="10px"
                          margin="15px 0"
                          color="#fff"
                          onClick={() => {
                            setIsInvesting({ type: "SELECT_USER" });
                          }}
                        />
                      </div>
                      <div className=" md:mt-0 md:ml-2">
                        <CustomButton
                          variant="contained"
                          customColor="#159AA8"
                          children="Edit Investment"
                          width="250px"
                          height="40px"
                          padding="10px"
                          margin="15px 0"
                          color="#fff"
                          onClick={handleEditInvestment}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {pending ? (
              <Loader />
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                {investDetails.map((detail) => (
                  <div key={detail.id}>
                    <InvestDetailCard
                      width={"100%"}
                      height={84}
                      currency={state?.cycle?.currency || investment?.currency}
                      icon={detail.icon}
                      title={detail.title}
                      cardValue={detail.cardValue}
                      cardContent={detail.cardContent}
                    />
                  </div>
                ))}
              </div>
            )}

            {investment?.video_link && (
              <div className="my-5">
                <p className="text-lg mb-3 font-[500]">
                  {investment?.video_title}
                </p>
                <YouTube
                  videoId={getYoutubeVideoId(investment?.video_link)}
                  opts={{ width: "100%", height: "300px" }}
                />
              </div>
            )}

            <div
              style={{
                backgroundColor: "#F9FAFB",
                marginTop: "80px",
                height: "54px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box>
                <Tabs
                  value={activeTab}
                  onChange={handleTabChange}
                  aria-label="basic tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  <Tab
                    label="About Investment"
                    value="about"
                    sx={
                      activeTab === "about"
                        ? { ...tabStyle, color: "#000" }
                        : generalStyle
                    }
                  />
                  <Tab
                    label="Users Interested"
                    value="interests"
                    sx={activeTab === "interests" ? tabStyle : generalStyle}
                  />
                  <Tab
                    label="Users Invested"
                    value="users"
                    sx={activeTab === "users" ? tabStyle : generalStyle}
                  />
                  <Tab
                    label={"Payment Schedule"}
                    value="schedule"
                    sx={activeTab === "schedule" ? tabStyle : generalStyle}
                  />

                  <Tab
                    label={
                      isMudarabah ||
                      investment?.investment_category?.name === "Real Estate"
                        ? "Payment History"
                        : "Payout History"
                    }
                    value="history"
                    sx={activeTab === "history" ? tabStyle : generalStyle}
                  />
                </Tabs>
              </Box>
            </div>

            <div className="mt-8">
              {activeTab === "about" && <AboutInvestment />}
              {activeTab === "interests" && (
                <UserInterested
                  investmentID={state?.cycle?.id}
                  cycle={state?.cycle}
                />
              )}
              {activeTab === "users" && <UserInvested cycle={state?.cycle} />}
              {activeTab === "schedule" && (
                <PaymentSchedule
                  cycle={state?.cycle}
                  hidePayoutButton={
                    investment?.investment_category?.name === "Real Estate" ||
                    isMudarabah
                  }
                />
              )}
              {activeTab === "history" && (
                <PayoutHistory
                  currency={investment?.currency}
                  type={
                    isMudarabah
                      ? "Real Estate"
                      : investment?.investment_category?.name
                  }
                  cycle={state?.cycle}
                />
              )}
            </div>
          </div>
          <StartInvestmentModal
            open={openStartModal}
            setOpenStartModal={setOpenStartModal}
            invID={id}
            name={investment?.name}
            invType={investment?.investment_category?.name}
            payout_type={investment?.payout_type}
            currency={investment?.currency}
            amount={investment?.paymentSchedules?.total_amount}
            onClose={handleCloseStartModal}
          />
          {showDeleteModal && (
            <ConfirmDeleteModal
              loading={loadingDelete}
              open={showDeleteModal}
              handleDelete={
                state?.type === "Real Estate"
                  ? () => handleDeleteRealEstate(investment?.id)
                  : handleDelete
              }
              onClose={() => setShowDeleteModal(false)}
            />
          )}

          {showTimelines && (
            <UpdatTimelineModal
              investment_id={investment?.id}
              open={showTimelines}
              onClose={() => setShowTimelines(false)}
            />
          )}
          {openModal ? (
            <PayoutModal
              open={openModal}
              invID={id}
              cycle_id={state?.cycle?.id}
              cycle={state?.cycle}
              currency={state?.cycle?.currency || investment?.currency}
              type={
                investment?.investment_category?.name === "Real Estate"
                  ? "Real Estate"
                  : "Manual"
              }
              onClose={handleCloseModal}
              setOpenModal={setOpenModal}
            />
          ) : (
            <></>
          )}
          {openMudarabahModal ? (
            <MudarabahPayoutModal
              open={openMudarabahModal}
              invID={id}
              cycle={state?.cycle}
              currency={state?.cycle?.currency || investment?.currency}
              refresh={() => {
                dispatch(getInvestment(id));
                refreshPayoutHistory();
              }}
              onClose={() => setOpenMudarabahModal(false)}
              setOpenModal={setOpenMudarabahModal}
            />
          ) : (
            <></>
          )}
          {openBreakDownModal ? (
            <ETCBreakDownModal
              open={openBreakDownModal}
              invID={id}
              cycle={state?.cycle}
              currency={investment?.currency}
              investment_category_id={investment?.investment_category?.id}
              onClose={() => {
                setOpenBreakDownModal(false);
              }}
              setOpenModal={setOpenBreakDownModal}
            />
          ) : (
            <></>
          )}
        </div>
      )}
    </DashboardLayout>
  );
}

export default InvestmentDetail;
